<template>
  <svg
    width="65"
    height="65"
    viewBox="0 0 65 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M51.3176 41.9062C46.123 41.9062 41.8957 46.1324 41.8957 51.3281C41.8957 56.5237 46.123 60.7499 51.3176 60.7499C56.5122 60.7499 60.7394 56.5237 60.7394 51.3281C60.7394 46.1324 56.5132 41.9062 51.3176 41.9062ZM51.3176 58.6562C47.2766 58.6562 43.9894 55.368 43.9894 51.3281C43.9894 47.2882 47.2766 43.9999 51.3176 43.9999C55.3585 43.9999 58.6457 47.2882 58.6457 51.3281C58.6457 55.368 55.3585 58.6562 51.3176 58.6562Z"
      fill="#343A40"
    />
    <path
      d="M49.2238 52.9884L47.8702 51.6348L46.3899 53.1151L49.2238 55.9489L56.2452 48.9275L54.7649 47.4473L49.2238 52.9884Z"
      fill="#343A40"
    />
    <path
      d="M64.9269 51.3281C64.9269 49.5065 64.1261 47.7771 62.7568 46.5899C62.8845 44.7819 62.2291 42.9939 60.9415 41.7062C60.0244 40.7881 58.8509 40.2008 57.5999 39.9799V3.17285C57.5999 1.44132 56.1908 0.0322266 54.4592 0.0322266H12.5842C10.8527 0.0322266 9.4436 1.44132 9.4436 3.17285V14.6874H0.0217285V33.5312H9.4436V59.7031C9.4436 61.4346 10.8527 62.8437 12.5842 62.8437H46.6537C47.8377 64.1638 49.5316 64.9374 51.3186 64.9374C53.1412 64.9374 54.8696 64.1366 56.0568 62.7683C57.8658 62.8887 59.6538 62.2407 60.9415 60.952C62.2291 59.6643 62.8855 57.8763 62.7578 56.0683C64.1261 54.8801 64.9269 53.1517 64.9269 51.3281ZM8.39568 16.7812H12.5832V18.8749H8.39568V16.7812ZM2.11443 31.4374V16.7812H6.30193V20.9687H14.6769V16.7812H18.8644V31.4374H2.11443ZM12.5832 60.7499C12.0064 60.7499 11.5363 60.2809 11.5363 59.7031V33.5312H20.9582V14.6874H11.5363V3.17285C11.5363 2.59498 12.0064 2.12598 12.5832 2.12598H54.4582C55.035 2.12598 55.5051 2.59498 55.5051 3.17285V39.3361C54.364 38.3102 52.8764 37.7197 51.3176 37.7197C49.4949 37.7197 47.7666 38.5216 46.5794 39.8899C44.7694 39.7674 42.9813 40.4175 41.6947 41.7062C40.407 42.9939 39.7506 44.7819 39.8784 46.5899C38.509 47.7781 37.7082 49.5065 37.7082 51.3281C37.7082 53.1507 38.509 54.8801 39.8784 56.0673C39.7569 57.7852 40.3505 59.479 41.5136 60.7499H12.5832ZM61.0451 54.7513L60.5018 55.1334L60.6159 55.7877C60.8514 57.1351 60.4191 58.5128 59.4601 59.4717C58.5023 60.4317 57.1277 60.8651 55.7772 60.6274L55.1229 60.5133L54.7408 61.0588C53.9546 62.1768 52.6754 62.8458 51.3186 62.8458C49.9619 62.8458 48.6826 62.1768 47.8964 61.0588L47.5143 60.5133L46.86 60.6274C45.5116 60.8672 44.1349 60.4317 43.176 59.4717C42.2171 58.5128 41.7847 57.1361 42.0203 55.7877L42.1344 55.1334L41.591 54.7513C40.4719 53.9651 39.803 52.6848 39.803 51.3281C39.803 49.9724 40.4719 48.692 41.591 47.9058L42.1344 47.5237L42.0203 46.8694C41.7847 45.5221 42.2171 44.1444 43.176 43.1855C44.1339 42.2255 45.5095 41.791 46.8589 42.0297L47.5132 42.1438L47.8953 41.5984C48.6815 40.4793 49.9608 39.8103 51.3176 39.8103C52.6743 39.8103 53.9525 40.4793 54.7398 41.5984L55.1219 42.1438L55.7762 42.0297C57.1277 41.791 58.5012 42.2255 59.4601 43.1855C60.4191 44.1444 60.8514 45.521 60.6159 46.8694L60.5018 47.5237L61.0451 47.9058C62.1642 48.692 62.8332 49.9724 62.8332 51.3281C62.8332 52.6848 62.1642 53.9651 61.0451 54.7513Z"
      fill="#343A40"
    />
    <path
      d="M53.4113 4.21869H13.6301V12.5937H53.4113V4.21869ZM51.3176 10.4999H15.7238V6.31244H51.3176V10.4999Z"
      fill="#343A40"
    />
    <path
      d="M23.0519 14.6874H53.4113V16.7812H23.0519V14.6874Z"
      fill="#343A40"
    />
    <path
      d="M51.3176 18.8749H53.4113V20.9687H51.3176V18.8749Z"
      fill="#343A40"
    />
    <path
      d="M35.6144 18.8749H49.2238V20.9687H35.6144V18.8749Z"
      fill="#343A40"
    />
    <path
      d="M23.0519 18.8749H33.5207V20.9687H23.0519V18.8749Z"
      fill="#343A40"
    />
    <path
      d="M23.0519 23.0624H53.4113V25.1562H23.0519V23.0624Z"
      fill="#343A40"
    />
    <path
      d="M37.7082 27.2499H53.4113V29.3437H37.7082V27.2499Z"
      fill="#343A40"
    />
    <path
      d="M23.0519 27.2499H35.6144V29.3437H23.0519V27.2499Z"
      fill="#343A40"
    />
    <path
      d="M23.0519 31.4374H53.4113V33.5312H23.0519V31.4374Z"
      fill="#343A40"
    />
    <path
      d="M13.6301 46.0937H24.0988V35.6249H13.6301V46.0937ZM15.7238 37.7187H22.0051V43.9999H15.7238V37.7187Z"
      fill="#343A40"
    />
    <path
      d="M33.5207 39.8124H35.6144V41.9062H33.5207V39.8124Z"
      fill="#343A40"
    />
    <path
      d="M26.1926 39.8124H31.4269V41.9062H26.1926V39.8124Z"
      fill="#343A40"
    />
    <path
      d="M26.1926 35.6249H35.6144V37.7187H26.1926V35.6249Z"
      fill="#343A40"
    />
    <path
      d="M26.1926 43.9999H35.6144V46.0937H26.1926V43.9999Z"
      fill="#343A40"
    />
    <path
      d="M13.6301 58.6562H24.0988V48.1874H13.6301V58.6562ZM15.7238 50.2812H22.0051V56.5624H15.7238V50.2812Z"
      fill="#343A40"
    />
    <path
      d="M26.1926 52.3749H35.6144V54.4687H26.1926V52.3749Z"
      fill="#343A40"
    />
    <path
      d="M26.1926 48.1874H35.6144V50.2812H26.1926V48.1874Z"
      fill="#343A40"
    />
    <path
      d="M26.1926 56.5624H31.4269V58.6562H26.1926V56.5624Z"
      fill="#343A40"
    />
    <path
      d="M33.5207 56.5624H35.6144V58.6562H33.5207V56.5624Z"
      fill="#343A40"
    />
  </svg>
</template>

<script>
export default {
  name: "LicenciamentoIcon",
};
</script>

<style>
</style>
